import { render, staticRenderFns } from "./ConventionSectionsMenu.vue?vue&type=template&id=4953dc02"
import script from "./ConventionSectionsMenu.vue?vue&type=script&lang=js"
export * from "./ConventionSectionsMenu.vue?vue&type=script&lang=js"
import style0 from "./ConventionSectionsMenu.vue?vue&type=style&index=0&id=4953dc02&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports